export function roleCheck(role, requiredRole){
  switch(requiredRole) {
  case 'user':
    return ['user', 'admin'].includes(role)
  case 'admin':
    return ['admin'].includes(role)
  default:
    return false
  }
}

export function isManagerOrAdmin(user){
  return !!user.attributes.manager || roleCheck(user.attributes.role, 'admin')
}